<script>
    import { CardLayout } from "../../../Components/Common/index.svelte";

    import {
        getText,
        getFormatDate,
        getFormatDateAndTime,
        getNumber,
        getHospitalType,
        getTitle,
        goToURL,
        getEncounterBillingType,
        getEncounterNeuraxialType,
    } from "../../../Utils/utilFunctions.svelte";

    export let procedureDetails = {};
    export let doctorDetails = {};

    $: hospitalDetails = { ...procedureDetails.hospital };

    $: surgeonDetails = { ...procedureDetails.surgeon };

    const bottomLinks = [
        {
            displayName: `View ${procedureDetails.quoteOnly ? 'Fee Estimate' : 'Patient Encounter'}`,
            clickFunc: () => _redirectToPatientEncounter(),
        },
    ];

    // HELPER FUNCTIONS
    const _getSurgeonFullName = () => {
        const { firstName, lastName, title, speciality } = surgeonDetails;

        return `${getTitle(title)} ${firstName} ${lastName} ${speciality ? `(${speciality})` : ""}`;
    };

    const _getEncounterTypeName = () => {
        const { typeOfBill, neuraxialType } = procedureDetails;

        if (typeOfBill != 2 || !neuraxialType)
            return getEncounterBillingType(typeOfBill);

        return `${getEncounterBillingType(typeOfBill)} (${getEncounterNeuraxialType(neuraxialType)})`;
    };

    const _getDisplayDate = (date) => {
        if (!date) return "";

        const formatDate = getFormatDateAndTime(date);

        const formatDateArr = formatDate.split(", ");

        return formatDateArr[1] == "00:00" ? formatDateArr[0] : formatDate;
    };

    const _getDoctorFullName = () => {
        const { firstName, lastName, title } = doctorDetails;

        return `${getTitle(title)} ${firstName} ${lastName}`;
    };

    const _redirectToPatientEncounter = () => {
        if(procedureDetails.quoteOnly) {
            goToURL(
                `/PatientQuote/view/${procedureDetails.patientEncounterId}`,
            );
        } else {
            goToURL(
                `/PatientEncounter/view/${procedureDetails.patientEncounterId}`,
            );
        }
       
    };

    const _redirectToDoctor = () =>
        goToURL(`/Account/view/${doctorDetails.id}`);

    const _redirectToHospital = () =>
        goToURL(`/Hospitals/view/${hospitalDetails.id}`);
</script>

<CardLayout title="Procedure Details" {bottomLinks}>
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Encounter Type:</p>
                <p class="content">
                    {_getEncounterTypeName()}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Procedure Name:</p>
                <p class="content">
                    {getText(procedureDetails.procedureName)}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Scheduled Date:</p>
                <p class="content">
                    {_getDisplayDate(procedureDetails.scheduledDate)}
                </p>
            </div>
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Doctor:</p>
                <p
                    class="content cursor-pointer underline font-bold"
                    on:click|preventDefault={_redirectToDoctor}
                >
                    {_getDoctorFullName()}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Provider No.:</p>

                <p class="content">{doctorDetails.number}</p>
            </div>

            {#if hospitalDetails.id}
                <div class="flex flex-row gap-x-2">
                    <p class="title">Hospital Name:</p>
                    <p
                        class="content cursor-pointer underline font-bold"
                        on:click|preventDefault={_redirectToHospital}
                    >
                        {getText(hospitalDetails.name)}{hospitalDetails.state
                            ? `, ${hospitalDetails.state}`
                            : ""}
                    </p>
                </div>
            {:else}
                <p>No Hospital Information...</p>
            {/if}

            {#if surgeonDetails.id}
                <div class="flex flex-row gap-x-2">
                    <p class="title">Surgeon/Referrer Full Name:</p>
                    <p class="content">{_getSurgeonFullName()}</p>
                </div>
            {:else}
                <p>No Surgeon/Referrer Information...</p>
            {/if}
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Encounter Created Date:</p>
                <p class="content">
                    {getFormatDate(procedureDetails.createdDate)}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Last Updated Date:</p>
                <p class="content">
                    {getFormatDate(procedureDetails.updatedDate)}
                </p>
            </div>
        </div>
    </div>
</CardLayout>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
